import { AppContext } from "@lightspeed-invoicing/core-client/frontend";
import React, { Component } from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { Link } from 'react-router-dom';
import Icon from "../../../common/icon/icon.component.jsx";
import OrderStatusBadge from "../../../order/status.component.jsx";

class OrderFromQuoteCreatedEvent extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            object: this.props.object || null,
            proposal: this.props.proposal || null,
            quote: this.props.quote || null,
            order: null,
        }

        this.getOrder = this.getOrder.bind(this)
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            object: nextProps.object || null,
            proposal: nextProps.proposal || null,
            quote: nextProps.quote || null,
        })
    }

    getOrder = async () => {
        const { quote } = this.state
        let orderId = ""

        if (quote.attributes.orderId !== "") {
            orderId = quote.attributes.orderId
        } else if (quote.attributes.orderIds && quote.attributes.orderIds.length > 0) {
            orderId = quote.attributes.orderIds[0]
        }
        
        if (orderId !== "") {
            try {
                const res = await AppContext.getApiClient().get('/orders/' + orderId)
                this.setState({
                    order: res
                })
            } catch (error) {
                console.error("Error fetching order:", error)
            }
        }
    }

    async componentDidMount() {
        await this.getOrder()
    }

    render() {
        if (!this.state.order || this.state.order.error) {
            return <div />
        }
        return <div className={"row " + this.state.className}>
            <div className="col-12">
                <p className={'mb-0'} data-document-event="order-from-quote-created">
                    <FormattedMessage
                        id="quote.analytics.events.order_from_quote_created.text"
                        defaultMessage="The order {order} has been created from the quote {quote}"
                        values={{
                            order: <strong>
                                <Link to={'/orders/' + this.state.order.id + '/edit'}>
                                    {this.state.order.attributes.identifier}
                                </Link>
                            </strong>,
                            quote: <strong>{this.state.quote.attributes.identifier}</strong>,
                        }}
                    />
                </p>
            </div>
            <div className={'col-12 d-flex align-items-center flex-wrap'}>
                <div className={'mr-5'}>
                    <h3 className={"m-0"}>
                        <Icon value={"order"} />
                    </h3>
                </div>
                <div className={'mr-5'}>
                    <div className={'w-100'}>
                        <label className="col-form-label custom-form-label">
                            <strong>
                                <FormattedMessage
                                    id="quote.analytics.events.invoice_created.total_amount"
                                    defaultMessage="Total amount"
                                />
                            </strong>
                        </label>
                    </div>
                    <h4 className={"m-0"}>
                        <FormattedNumber
                            value={this.state.order.attributes.totalAmount}
                            style={'currency'}
                            currency={this.state.order.attributes.currency}
                        />
                    </h4>
                </div>
                <div>
                    <div className={'w-100'}>
                        <label className="col-form-label custom-form-label">
                            <strong>
                                <FormattedMessage
                                    id="quote.analytics.events.order_created.status"
                                    defaultMessage="Status"
                                />
                            </strong>
                        </label>
                    </div>
                    <h5 className={"m-0 border-0 mb-0"}>
                        <OrderStatusBadge statusId={this.state.order.attributes.customStatusId} />
                    </h5>
                </div>

            </div>
        </div>
    }

}

export default OrderFromQuoteCreatedEvent





// WEBPACK FOOTER //
// ./src/quote/analytics/events/order-from-quote-created.component.jsx